/**
 * Slug generation shared by the client-side job form and the server-side MCP tools.
 *
 * Both paths must produce byte-identical slugs: a job created through `create_job`
 * and one created through `JobForm.vue` have to end up on the same URL for the same
 * title, otherwise how a job was created leaks into its public address.
 */

/** Convert a string to a URL-friendly slug. */
export const slugify = (text: string): string => {
    // NFKD splits diacritics into combining marks, which the class below then drops
    // together with punctuation — so "Hľadáme" becomes "hladame".
    let slug = text.normalize('NFKD').replace(/[^\w\s-]/g, '')

    slug = slug.toLowerCase().trim().replace(/\s+/g, '-')

    return slug.replace(/-+/g, '-')
}

/**
 * Job slugs are prefixed with the org slug — mirrors the `suggestSlug()` call in
 * `app/components/jobs/JobForm.vue`.
 */
export const buildJobSlug = (orgSlug: string | undefined | null, title: string): string =>
    slugify([orgSlug, title].filter(Boolean).join('-'))
